import { apiSlice } from './apiSlice';
const PAYMENTS_URL = '/api/payments';

export const paymentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: PAYMENTS_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Payments'],
    }),
    getPaymentDetails: builder.query({
      query: (paymentId) => ({
        url: `${PAYMENTS_URL}/${paymentId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createPayment: builder.mutation({
      query: (paymentData) => ({
        url: PAYMENTS_URL,
        method: 'POST',
        body: paymentData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Payments'],
    }),
    updatePayment: builder.mutation({
      query: ({ paymentId, ...data }) => ({
        url: `${PAYMENTS_URL}/${paymentId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Payments'],
    }),
    uploadPaymentImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    bulkUpdatePayments: builder.mutation({
  query: (paymentData) => ({
    url: `${PAYMENTS_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: paymentData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['Payments'],
}),
    deletePayment: builder.mutation({
      query: (paymentId) => ({
        url: `${PAYMENTS_URL}/${paymentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Payments'],
    }),
    createReview: builder.mutation({
      query: ({ paymentId, ...data }) => ({
        url: `${PAYMENTS_URL}/${paymentId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Payments'],
    }),
    getTopPayments: builder.query({
      query: () => `${PAYMENTS_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});


export const {
  useGetPaymentsQuery,
  useGetPaymentDetailsQuery,
  useCreatePaymentMutation,
  useUpdatePaymentMutation,
  useUploadPaymentImagesMutation,
  useDeletePaymentMutation,
  useCreateReviewMutation,
  useGetTopPaymentsQuery,
  useBulkUpdatePaymentsMutation,
} = paymentsApiSlice;